const Arlam = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9993 29.0002C18.9653 29.0002 21.3696 26.5307 21.3696 23.4845C21.3696 20.4382 18.9653 17.9688 15.9993 17.9688C13.0333 17.9688 10.6289 20.4382 10.6289 23.4845C10.6289 26.5307 13.0333 29.0002 15.9993 29.0002Z"
        fill="#FF8A00"
      />
      <path
        d="M16.0019 8.72C17.5411 8.72 18.7889 7.43954 18.7889 5.86C18.7889 4.28047 17.5411 3 16.0019 3C14.4626 3 13.2148 4.28047 13.2148 5.86C13.2148 7.43954 14.4626 8.72 16.0019 8.72Z"
        fill="#FFC61C"
      />
      <path
        d="M16.0003 5.49805C21.2966 5.49805 25.6021 9.80662 25.6021 15.1273V25.4716H6.39844V15.1273C6.39844 9.80662 10.704 5.49805 16.0003 5.49805Z"
        fill="#FFC61C"
      />
      <path
        d="M26.5278 21.5156H5.47222C4.38299 21.5156 3.5 22.3991 3.5 23.4888C3.5 24.5786 4.38299 25.4621 5.47222 25.4621H26.5278C27.617 25.4621 28.5 24.5786 28.5 23.4888C28.5 22.3991 27.617 21.5156 26.5278 21.5156Z"
        fill="#FFC61C"
      />
    </svg>
  );
};

export default Arlam;
